import styled from 'styled-components';

export const PageTemplate = styled.div`
  background-color: #fff;
  min-height: 100vh;
`;

export const Wrap = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;
